import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare function HomevoiceOnKeyPress(value, key): any;
declare function HomeresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare var $: any;
declare function ADAModelMessage(eventId, innerText): any;

@Component({
  selector: 'app-dacfooter',
  templateUrl: './dacfooter.component.html',
  styleUrls: ['./dacfooter.component.css']
})
export class DacfooterComponent implements OnInit { 
  route: string;
  pathname = '';
  constructor() { }
  onKeyUp(event: any) {
    debugger;    
    if (event.target.id == "footerada" && event.keyCode == 13) {
      ADAModelMessage("", "");
      $("#myModal").modal('show');
      //ADAModelMessage(event.target.id, event.target.innerText);          
      return;
    }
    if (event.target.id == "myModal" && event.keyCode == 9) {
      ADAModelMessage(event.target.id, event.target.innerText);
      $('#adasectionHeader').focus();      
      return;
    }
    if (event.target.id == "adasectionHeader" && event.keyCode == 9) {      
      ADAModelMessage(event.target.id, event.target.innerText);
      return;
    }
    if (event.target.id == "divADABond" && event.keyCode == 9) {
      ADAModelMessage(event.target.id, event.target.innerText);
      return;
    }
    if (event.target.id == "btnClosePopup" && event.keyCode == 9) {
      ADAModelMessage(event.target.id, event.target.innerText);
      return;
    }

    //if (event.target.id == "SkipMainContentfooter" && event.keyCode == 9) {
    //  document.getElementById("divAboutTitle").tabIndex = -1;
    //}

    this.pathname = window.location.pathname;
    if (event.keyCode == 9 || event.keyCode == 13) {
      if (event.target.id == "divEndofpage") {
        HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContent").innerText, event.target.id, event.target.type, document.getElementById("SkipMainContent").title, event.target.htmlFor, event.target.alt, event.key);
        return;
      }
      else {
        if (event.target.id == "footerada" && event.keyCode == 13) {

        }
        else {
          HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
    }    
  };

  onClick(event: any) {
    debugger;
    if (event.target.id == "SkipMainContentfooter") {      
      document.getElementById("SkipMainContent").focus();
      document.getElementById("SkipMainContent").tabIndex = 17;
      HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContent").innerText, event.target.id, event.target.type, document.getElementById("SkipMainContent").title, event.target.htmlFor, event.target.alt, event.key);
    }
  }
  onkeypress(event: any) {
    debugger;    
    if (event.target.id == "footerada" && event.keyCode == 13) {
      return;
    }
    this.pathname = window.location.pathname;
    if (event.keyCode == 9 || event.keyCode == 13) {
      if (event.target.id == "SkipMainContentfooter") {                  
          HomeresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContent").innerText, event.target.id, event.target.type, document.getElementById("SkipMainContent").title, event.target.htmlFor, event.target.alt, event.key);
          document.getElementById("SkipMainContent").focus();
          document.getElementById("SkipMainContent").tabIndex = 17;
          return;                
      }
    }    
  }

  showModal() {
    debugger;
    ADAModelMessage("", "");
  }

  ngOnInit() {
    debugger;
    $('#myModal').on('shown.bs.modal', function () {
      debugger;     
      $('#lblhdnada').focus();      
    });

    $("#myModal").on("hidden.bs.modal", function () {
      debugger;      
      $("#contactNo").focus();      
      ADAModelMessage("CloseModelPopup", "");
    });

  }
}
